const getConfig = (key: string, defaultValue: string): string => {
    return (window as any)[key] || process.env[key] || defaultValue;
};

const normalizeFlag = (value: string): boolean => {
    return value === 'true' || value === '1';
};

const backendURI = getConfig(
    'VITE_BACKEND_URI',
    'https://paula-backend-staging.edukita.com'
);

export default {
    environment: getConfig('NODE_ENV', 'dev'),
    googleClientId: getConfig('VITE_GOOGLE_CLIENT_ID', ''),
    backendURI,
    sentry: {
        dsn: getConfig('VITE_SENTRY_DSN', ''),
        tracesSampleRate: getConfig('VITE_SENTRY_TRACES_SAMPLE_RATE', '0.1'),
    },
    naraBackendURI: getConfig(
        'VITE_NARA_BACKEND_URI',
        'https://nara-staging.edukita.com'
    ),
    pythagorasURI: getConfig(
        'VITE_PYTHAGORAS_URI',
        'https://math-staging.edukita.com'
    ),
    gtmID: getConfig('VITE_GTM_ID', 'GTM-T52'),
    defaultLocale: getConfig('VITE_DEFAULT_LOCALE', 'en'),
    defaultHomeUrl: '/schedule/v2',
    apiUseMocks: normalizeFlag(getConfig('VITE_API_USE_MOCKS', 'false')),
    e2eBypassAuth: normalizeFlag(getConfig('VITE_E2E_BYPASS_AUTH', 'false')),
    curriculumVersion: getConfig('VITE_CURRICULUM_VERSION', '2.0'),
};
